import BaseApiComponent from './baseApiComponent';

function ApiComponent(params: $TSFixMe) {
    return BaseApiComponent(ApiComponent, params);
}

export default ApiComponent;
